var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLpBackgroundMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 621,
    viewBox: "0 0 375 621",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2686_185201)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2686_185201)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 963,
    fill: "#1C33C3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2686_185201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1439.1 0H0V719H1439.1V0Z",
    fill: "#1434CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6291 592.82L103.252 535.828L62.9229 552.522L79.6291 592.82Z",
    fill: "#1434CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.869 109.55L433.635 193.06L430.029 201.751L542.791 155.08L484.448 14.3419L303.545 89.2194L266.56 0H212.415L190.262 9.16936L231.869 109.55Z",
    fill: "#2C48D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.325 316.724L170.068 124.349L45.6239 0H25.7177L0.897461 24.797V336.594L35.6687 371.338L90.325 316.724Z",
    fill: "#2C48D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.467 385.063L330.379 442.143L391.766 294.063L337.651 239.99L192.467 385.063Z",
    fill: "#2C48D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.683 574.409L437.31 521.689L437.306 521.694L389.748 636.421L415.452 698.432L365.757 719H647.563L665.67 675.319L564.683 574.409Z",
    fill: "#2C48D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.762 294.062L330.38 442.143L192.467 385.063L146.86 430.63L208.534 492.253L312.201 449.345L370.048 588.899L495.745 463.298L449.512 351.764L391.762 294.062Z",
    fill: "#2C48D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.048 588.899L337.652 621.271L208.534 492.253L103.251 535.828L79.6289 592.82L131.932 719H355.518L389.747 636.421L370.048 588.899Z",
    fill: "#2C48D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.068 124.349L90.3252 316.724L226.46 180.697L170.068 124.349Z",
    fill: "#122FB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.534 492.253L337.651 621.271L370.048 588.899L312.2 449.345L208.534 492.253Z",
    fill: "#122FB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.869 109.55L293.514 258.256L430.029 201.751L433.636 193.06L231.869 109.55Z",
    fill: "#122FB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6291 592.82L62.9228 552.522L103.252 535.828L151.555 419.304L0.897461 356.945V648.766L48.3032 668.387L79.6291 592.82Z",
    fill: "#122FB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.869 109.55L184.357 89.8834L170.068 124.349L226.459 180.697L90.3245 316.724L81.1016 338.97L192.467 385.063L337.647 239.989L391.762 294.063L430.029 201.751L293.513 258.256L231.869 109.55Z",
    fill: "#435DD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.56 0L303.545 89.2194L484.448 14.3419L478.506 0H266.56Z",
    fill: "#435DD5"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 643,
    fill: "url(#paint0_linear_2686_185201)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2686_185201",
    x1: 46.5487,
    y1: 321.5,
    x2: 290.893,
    y2: 321.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C33C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51823,
    stopColor: "#1C33C3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C33C3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2686_185201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 643,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2686_185201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 719,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2686_185201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 719,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpBackgroundMobile);
export default __webpack_public_path__ + "static/media/lp_background_mobile.a11065fa2c8d8dc6f8c5604795920250.svg";
export { ForwardRef as ReactComponent };